import { createStore } from 'redux';
import searchFormReducer from './reducers/searchFormReducer';
import {
  initDepartureDate,
  initalDepartureCity,
  initialDestinationCountry,
  initialNightsFrom,
  initialNightsTo,
  initialAdultsCount,
  initialKids,
  initialCurrency,
} from '../Utils/Constants/InitialStateUtils';
import { isAccessTokenValid } from '../Utils/CommonUtils';

function configureStore(
  state = {
    adults: initialAdultsCount,
    kids: initialKids,
    depatureCity: initalDepartureCity,
    departureDate: initDepartureDate(),
    calendarSelected: initDepartureDate(),
    destination: initialDestinationCountry,
    searchInputValue: '',
    selectedResorts: [],
    resortOptions: [],
    isPopupVisible: false,
    nightsFrom: initialNightsFrom,
    nightsTo: initialNightsTo,
    selectionNightsFrom: initialNightsFrom,
    selectionNightsTo: initialNightsTo,
    searchResult: [],
    isLoginModalVisible: false,
    isUserLoggedIn:
      window.localStorage.getItem('isUserLoggedIn') === 'true' &&
      isAccessTokenValid(),
    userName: {},
    availableDays: [],
    availableDaysKey: '',
    timeIsUpModalVisible: false,
    hotelDetailsFilterMenuVisibility: false,
    currency: initialCurrency,

    destinationButton: null,
    nightsButton: null,

    // filters
    hotelsFilter: [],
    selectedHotels: [],

    starsFilter: 1,
    starsFilterHover: 1,

    mealsFilter: {},
    ratingFilter: 0,
    beachLineFilter: 0,
    beachTypesFilter: [],
    hotelTypeFilter: [],
    hotelServicesFilter: [],
    onlyCharter: 1,
    directFlight: 0,

    regionsOptions: [],
    isAllRegionsFilterTab: true,

    operatorsFilter: [],
    isAllOperatorsTab: true,

    maxPriceFilter: 0,
    minPriceFilter: 0,

    touristsSearchText: '',
    datesSearchText: '',
    contactModalVisible: false,
    helpModalVisible: false,
    userFirstLetter: '',

    otherToursCoords: { top: 0, left: 0 },
    touristsPopupVisible: false,
  },
) {
  return createStore(searchFormReducer, state);
}

export default configureStore;
